import {useContext} from "react";
import {
    Tab,
} from "semantic-ui-react";
import { Table } from "antd";
import {TemplateContext} from "../../../../utils/template_context";

const TabEducation = ({ datos, userState, handleOpenModal, handleCloseModal }: any) => {

    //console.log(userState)
    const context = useContext(TemplateContext);

    const columns: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "lg"? "left": false,
            width: 40,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Título',
            key: 'titulo',
            dataIndex: 'titulo',
            width: 300,
        },
        {
            title: 'Nivel de educación',
            key: 'nivel_educacion',
            dataIndex: 'nivel_educacion',
            width: 190,
        },
        {
            title: 'Institución educativa',
            key: 'institucion_educativa',
            dataIndex: 'institucion_educativa',
            width: 300,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
        {
            title: 'Graduado',
            key: 'graduado',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.graduado === true ? "si" : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de graduación',
            key: 'fecha_graduacion',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>
                    {datos.fecha_graduacion ?
                        (
                            <div>{datos.fecha_graduacion}</div>
                        )
                        :
                        (
                            <div>No aplica</div>
                        )
                    }
                </div>
            )
        },
        {
            title: 'Anexo',
            key: 'anexo',
            width: 100,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any, record: any, index: number) => (
                <span onClick={() => handleOpenModal(datos.path_anexo)}> Ver Anexo</span>
            )
        },
    ]

    const columnsSinAnexo: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "md"? "left": false,
            width: 50,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Título',
            key: 'titulo',
            dataIndex: 'titulo',
            width: 300,
        },
        {
            title: 'Nivel de educación',
            key: 'nivel_educacion',
            dataIndex: 'nivel_educacion',
            width: 190,
        },
        {
            title: 'Institución educativa',
            key: 'institucion_educativa',
            dataIndex: 'institucion_educativa',
            width: 300,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
        {
            title: 'Graduado',
            key: 'graduado',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.graduado === true ? "si" : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de graduación',
            key: 'fecha_graduacion',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>
                    {datos.fecha_graduacion ?
                        (
                            <div>{datos.fecha_graduacion}</div>
                        )
                        :
                        (
                            <div>No aplica</div>
                        )
                    }
                </div>
            )
        },
    ]

    const columns2: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "md"? "left": false,
            width: 60,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Nombre',
            key: 'nombre_educacion',
            dataIndex: 'nombre_educacion',
            width: 200,
        },
        {
            title: 'Proceso',
            key: 'nombre_proceso',
            dataIndex: 'nombre_proceso',
            width: 190,
        },
        {
            title: 'Duración',
            key: 'duracion',
            dataIndex: 'duracion',
            width: 150,
        },
        {
            title: 'Institución',
            key: 'institucion',
            dataIndex: 'institucion',
            width: 150,
        },
        {
            title: 'Fecha de inicio',
            key: 'fecha_inicio',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.fecha_inicio ? datos.fecha_inicio : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de terminación',
            key: 'fecha_terminacion',
            dataIndex: 'fecha_terminacion',
            width: 150,
        },
        {
            title: 'Número de horas',
            key: 'numero_horas',
            dataIndex: 'numero_horas',
            width: 150,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
        {
            title: 'Anexo',
            key: 'anexo',
            width: 100,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any, record: any, index: number) => (
                <span onClick={() => handleOpenModal(datos.path_anexo)}> Ver Anexo</span>
            )
        },
    ]
    const columns2SinAnexo: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "md"? "left": false,
            width: 60,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Nombre',
            key: 'nombre_educacion',
            dataIndex: 'nombre_educacion',
            width: 200,
        },
        {
            title: 'Proceso',
            key: 'nombre_proceso',
            dataIndex: 'nombre_proceso',
            width: 190,
        },
        {
            title: 'Duración',
            key: 'duracion',
            dataIndex: 'duracion',
            width: 150,
        },
        {
            title: 'Institución',
            key: 'institucion',
            dataIndex: 'institucion',
            width: 150,
        },
        {
            title: 'Fecha de inicio',
            key: 'fecha_inicio',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.fecha_inicio ? datos.fecha_inicio : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de terminación',
            key: 'fecha_terminacion',
            dataIndex: 'fecha_terminacion',
            width: 150,
        },
        {
            title: 'Número de horas',
            key: 'numero_horas',
            dataIndex: 'numero_horas',
            width: 150,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
    ]



    const TabEducacionFormal = () => {


        return (
            <>
                <Table
                    dataSource={datos.educacion_formal}
                    columns={ userState ? columns : columnsSinAnexo}
                    scroll={{ x: 1500, y: 300 }}
                />
            </>
        );
    };
    const TabEducacionNoFormal = () => {
        return (
            <>
                <Table
                    dataSource={datos.educacion_no_formal}
                    columns={userState ? columns2 : columns2SinAnexo}
                    scroll={{ x: 1500, y: 300 }}
                />
                {/* <Table
                        columns={7}
                        compact
                        unstackable
                        fixed
                        singleLine
                        striped
                        size="large"
                        className="border-right-left-none border-bottom-none"
                        scroll={{ x: 1500 }}
                    >
                        <Table.Header fullWidth>
                            <Table.Row>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={1}
                                >
                                    No.
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={2}
                                >
                                    Nombre
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={2}
                                >
                                    Proceso
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={1}
                                >
                                    Duración
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={1}
                                >
                                    Institución
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={2}
                                >
                                    Fecha de inicio
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={2}
                                >
                                    Fecha de terminación
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={2}
                                >
                                    Número de horas
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={2}
                                >
                                    Ciudad
                                </Table.HeaderCell>
                                { userState && (
                                <Table.HeaderCell
                                    className="background-color-FFFFFF font-size-12px"
                                    width={2}
                                >
                                    Anexos
                                </Table.HeaderCell>)}
                            </Table.Row>
                        </Table.Header>
                        {datos && datos.educacion_no_formal ? (
                            <Table.Body style={{ height: "100%" }}>
                                {datos.educacion_no_formal.map((datos: any, index: number) => (
                                    <Table.Row key={index}>
                                        <Table.Cell
                                            className="font-size-12px font-family-Work-Sans"
                                            width={1}
                                        >
                                            {index + 1}
                                        </Table.Cell>
                                        <Table.Cell
                                            className="font-size-12px font-family-Work-Sans"
                                            width={3}
                                        >
                                            {datos.nombre_educacion}
                                        </Table.Cell>
                                        <Table.Cell
                                            className="font-size-12px font-family-Work-Sans"
                                            width={2}
                                        >
                                            {datos.nombre_proceso}
                                        </Table.Cell>

                                        <Table.Cell
                                            width={1}
                                            className="font-size-12px font-family-Work-Sans"
                                        >
                                            {datos.duracion}
                                        </Table.Cell>
                                        <Table.Cell
                                            width={1}
                                            className="font-size-12px font-family-Work-Sans"
                                        >
                                            {datos.institucion}
                                        </Table.Cell>
                                        <Table.Cell
                                            width={1}
                                            className="font-size-12px font-family-Work-Sans"
                                        >
                                            {datos.fecha_inicio ? datos.fecha_inicio : "No aplica"}
                                        </Table.Cell>
                                        <Table.Cell
                                            width={1}
                                            className="font-size-12px font-family-Work-Sans"
                                        >
                                            {datos.fecha_terminacion}
                                        </Table.Cell>
                                        <Table.Cell
                                            width={1}
                                            className="font-size-12px font-family-Work-Sans"
                                        >
                                            {datos.numero_horas}
                                        </Table.Cell>
                                        <Table.Cell
                                            width={1}
                                            className="font-size-12px font-family-Work-Sans"
                                        >
                                            {datos.ciudad}
                                        </Table.Cell>
                                        { userState && (
                                            <Table.Cell
                                            width={1}
                                            className="font-size-12px font-family-Work-Sans"
                                        >
                                          <span  onClick={()=>handleOpenModal(datos.path_anexo)}> Ver Anexo</span>
                                        </Table.Cell>
                                  
                                        )}
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        ) : null }
                    </Table> */}
            </>
        );
    };
    const educationPanes = [
        {
            menuItem: "Educación formal",
            render: () => (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                    <TabEducacionFormal />
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Educación no formal",
            render: () => (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                    {" "}
                    <TabEducacionNoFormal />
                </Tab.Pane>
            ),
        },
    ];
    const EducationTabs = () => (
        <Tab
            panes={educationPanes}
            menu={{ secondary: true, pointing: true }}
            className="tabs-jurados"
            renderActiveOnly={true}
        />
    );
    return (
        <EducationTabs />
    );
};


export default TabEducation